"use client";

import React, { useEffect, useState } from "react";
import SimilarProductLinks from "./SimilarProductLinks";

function SimilarProductsSkeleton() {
  return (
    <div className="space-y-1 pt-1 animate-pulse">
      {[1, 2, 3, 4].map((i) => (
        <div key={i} className="flex items-center gap-2">
          <div className="w-[48px] h-[48px] bg-gray-200 rounded" />
          <div className="h-4 bg-gray-200 rounded w-[100px]" />
        </div>
      ))}
    </div>
  );
}

const SimilarProductsSection = ({ productAlias, type }) => {
  const [products, setProducts] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!productAlias || !type) {
      setLoading(false);
      return;
    }

    const fetchSimilarProducts = async () => {
      try {
        const baseUrl = process.env.NEXT_PUBLIC_BASE_URL;
        const res = await fetch(
          `${baseUrl}/products/public-similar-products/${productAlias}/${type}`,
          { headers: { "Content-Type": "application/json" } }
        );
        if (!res.ok) return;
        const data = await res.json();
        const similar = data?.similarProducts || [];
        setProducts(similar);
      } catch (err) {
        console.error("[SimilarProducts] fetch error:", err);
        setProducts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchSimilarProducts();
  }, [productAlias, type]);

  // Hide section if no products and done loading
  if (!loading && (!products || products.length === 0)) return null;

  return (
    <div className="bg-white p-2 rounded-lg flex-1">
      <div className="pb-2 border-b text-[16px] font-semibold font-poppins text-[#4B4B4B] border-[#E1E1E1]">
        Similar Products
      </div>
      {loading ? <SimilarProductsSkeleton /> : <SimilarProductLinks products={products} />}
    </div>
  );
};

export default SimilarProductsSection;
